import { showAccountVerificationStatus } from 'Webapp/shared/app/redux/selectors/account-verification-status';

export default {
  selectors: {
    showAccountVerificationStatus,
  },
};
